const defaultOptions = {
	format: 'image/png',
	quality: 0.92,
	width: undefined,
	height: undefined,
	Canvas: undefined,
	crossOrigin: undefined,
};

const _drawImages = (ctx, image) => {
	ctx.globalAlpha = image.opacity ? image.opacity : 1;
	if (image.width && image.height) {
		return ctx.drawImage(image.img, image.x || 0, image.y || 0, image.width, image.height);
	}
	return ctx.drawImage(image.img, image.x || 0, image.y || 0);
};

const _loadSources = (ImageCtor, sources, options) =>
	sources.map(
		(source) =>
			new Promise((resolve, reject) => {
				const normalized = source.constructor.name !== 'Object' ? { src: source } : source;

				const img = new ImageCtor();
				img.crossOrigin = options.crossOrigin;
				img.onerror = () => reject(new Error("Couldn't load image"));
				img.onload = () => resolve({ ...normalized, img });
				img.src = normalized.src;
			})
	);

/**
 * Composites several images onto a canvas and returns a data URL.
 */
const mergeImages = (sources = [], userOptions = {}) =>
	new Promise((resolve) => {
		const options = { ...defaultOptions, ...userOptions };

		const canvas = options.Canvas ? new options.Canvas() : window.document.createElement('canvas');
		const ImageCtor = options.Image || window.Image;

		const images = _loadSources(ImageCtor, sources, options);
		const ctx = canvas.getContext('2d');

		resolve(
			Promise.all(images).then((loaded) => {
				const getSize = (dim) => options[dim] || Math.max(...loaded.map((image) => image.img[dim]));
				canvas.width = getSize('width');
				canvas.height = getSize('height');

				loaded.forEach((img) => _drawImages(ctx, img));

				return canvas.toDataURL(options.format, options.quality);
			})
		);
	});

export default mergeImages;
